import { Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";

export const ClassSettingModal = ({
  open,
  onClose,
  className,
  handleClassNameChange,
  handleOpenStudentModal,
  canEditStudent,
  handleDeleteClass,
}: {
  open: boolean;
  onClose: () => void;
  className?: string;
  handleClassNameChange: (className: string) => void;
  handleOpenStudentModal: () => void;
  canEditStudent: boolean;
  handleDeleteClass?: () => void;
}) => {
  const [currentClassName, setCurrentClassName] = useState("");

  useEffect(() => {
    setCurrentClassName(className || "");
  }, [className]);
  return (
    <div
      onClick={onClose}
      className={`fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-20 p-4 ${
        open ? "block" : "hidden"
      }`}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white p-6 md:p-10 rounded-lg flex flex-col gap-4 max-w-[460px] w-full max-h-[90vh] overflow-y-auto"
      >
        <div className="flex items-center justify-center p-4 bg-primary-light text-lg font-medium text-white rounded-sm">
          班級設定
        </div>
        <div className="flex gap-3 sm:gap-4 flex-col sm:flex-row">
          <TextField
            label="班級名稱"
            variant="outlined"
            fullWidth
            value={currentClassName}
            onChange={(e) => setCurrentClassName(e.target.value)}
            sx={{ backgroundColor: "white" }}
          />
          <Button
            onClick={() => handleClassNameChange(currentClassName)}
            color="error"
            variant="contained"
            sx={{ textWrap: "nowrap", px: "24px", py: { xs: "12px", sm: "8px" } }}
            disabled={currentClassName === className || currentClassName === ""}
          >
            確認變更
          </Button>
        </div>
        <Button disabled={!canEditStudent} variant="outlined" onClick={handleOpenStudentModal}>
          編輯學生資料
        </Button>
        {handleDeleteClass && (
          <Button
            variant="outlined"
            color="error"
            onClick={handleDeleteClass}
          >
            刪除班級
          </Button>
        )}
      </div>
    </div>
  );
};